/**
 * @author  Kheops Technologies SA <devops@kheops.ch>
 * @copyright Kheops Technologies SA
 */
import OxVueWrap from './OxVueWrap.vue'
export * from './OxVueWrap.vue'
export default OxVueWrap
